export enum Parameter {
  P61_CUENTA_BANCOLOMBIA = 'P-61',
  P62_CONVENIO_BANCOLOMBIA = 'P-62',
  P63_CUENTA_ITAU = 'P-63',
  P64_CONVENIO_ITAU = 'P-64',
  P68_CONVENIO_BALOTO = 'P-68',
  P69_CONVENIO_EFECTY = 'P-69',
  P70_VALOR_MININO_PSE = 'P-70',
  P71_MENSAJE_ERROR_PSE = 'P-71',
  P81_VIGENCIA_SOLICITUD_ACTIVA = 'P-81',
  P128_CUENTA_DAVIVIENDA = 'P-128',
  SUSUERTE = 'susuerte',
  RAPIPLAZO = '2',
  RAPICREDITO = '1',
}
